import { Button, Grid, Typography } from '@mui/material';
import { ChannelType } from 'helpers/enums';
import { useContext } from 'react';
import { Amounts, BillingAddress, OrderDetails, Channel, Customer, ShippingAddress, OrderLines, Activities, EditOrder, LengowComments, DUESyncErrrors, EcomDetails, PaymentDetails, Due, OrderDocuments } from './components';
import { orderContext } from './OrderContext';


let Order = () => {
    let service = useContext(orderContext);

    return (
        <Grid container>
            {service.isLoading === false &&
                <>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs>
                                <Typography variant="h3">Order {service.order.orderId}</Typography>
                            </Grid>
                            {service.order.orderStatus === "New" && service.order.containsSportTechBrands === true && service.order.allSportTechBrands === false &&
                                <Grid item>
                                    <Button
                                        variant='contained'
                                        onClick={async () => await service.removeSportTechProducts()}
                                    >
                                        Remove Sport Tech Products
                                    </Button>
                                </Grid>
                            }
                            {service.order.orderStatus === "New" && service.order.containsSportTechBrands === true && service.order.allSportTechBrands === true &&
                                <Grid item>
                                    <Button
                                        variant='contained'
                                        onClick={async () => await service.deleteOrder()}
                                    >
                                       Delete order 
                                    </Button>
                                </Grid>
                            }
                            {service.order.userCanEditOrder === true &&
                                <Grid item>
                                    <Button
                                        variant='contained'
                                        onClick={async () => await service.retrySendOrder()}
                                    >
                                        Retry sending
                                    </Button>
                                </Grid>
                            }
                            {service.order.userCanEditOrder === true &&
                                <Grid item>
                                    <EditOrder />
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <OrderDetails />
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Channel />
                            </Grid>
                            <Grid item xs={12}>
                                <Due />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Amounts />
                    </Grid>
                    <Grid item xs={6}>
                        <BillingAddress />
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={12}>
                                <ShippingAddress />
                            </Grid>
                            <Grid item xs={12}>
                                <Customer />
                            </Grid>
                        </Grid>
                    </Grid>
                    {service.order.channelType === ChannelType.Lengow &&
                        <Grid item xs={6}>
                            <LengowComments />
                        </Grid>
                    }
                    {service.order.channelType === ChannelType.Ecom &&
                        <Grid item xs={6}>
                            <EcomDetails />
                        </Grid>
                    }
                    <Grid item xs={6}>
                        <PaymentDetails />
                    </Grid>
                    <Grid item xs={12}>
                        <OrderDocuments />
                    </Grid>
                    <Grid item xs={12}>
                        <OrderLines />
                    </Grid>
                    <Grid item xs={12}>
                        <DUESyncErrrors />
                    </Grid>
                    <Grid item xs={12}>
                        <Activities />
                    </Grid>
                </>
            }
        </Grid>
    );
}

export default Order;